import script from "./ColorPickr.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorPickr.vue?vue&type=script&setup=true&lang=ts"

import "./ColorPickr.vue?vue&type=style&index=0&id=6cdc79a0&lang=css"

const __exports__ = script;

export default __exports__